export const isEnterKey = (event) =>
  event.key === 'Enter' || event.which === 13 || event.keyCode === 13;
